import React from "react";
import PropTypes from "prop-types";
import { DialogContent, DialogActions, Button, Box } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { KisshtDialog } from "components/custom/KisshtDialog";
import InputField from "components/ui/form/InputField";
import "./CommonRemarksModal.scss";

const scheme = Yup.object().shape({
  remark: Yup.string()
    .required("Please enter remarks")
    .transform((value) => value?.trim())
    .matches(/^[^\p{Extended_Pictographic}]*$/u, "Emoji text is not allowed")
    .max(250, "Maximum 250 characters allowed"),
});

const CommonRemarksModal = ({ visible, title, handleClose, handleSubmit }) => {
  return (
    <KisshtDialog
      title={title}
      maxWidth="sm"
      open={visible}
      handleClose={handleClose}
    >
      <Formik
        initialValues={{ remark: "" }}
        validationSchema={scheme}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ touched, errors }) => (
          <Form noValidate>
            <DialogContent dividers={false} className="remarks-modal__body">
              <Box className="remarks-modal__field-group">
                <Field
                  style={{ width: "100%" }}
                  variant="outlined"
                  size="small"
                  label="Add Remarks"
                  id="remark"
                  placeholder="Add Remarks"
                  name="remark"
                  component={InputField}
                  touched={touched}
                  multiline
                  rows={4}
                />
              </Box>
            </DialogContent>

            <DialogActions>
              <Button
                variant="outlined"
                onClick={handleClose}
                type="button"
                className="remarks-modal__closeBtn"
              >
                Close
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="remarks-modal__submitBtn"
                disabled={Boolean(errors.remark)}
              >
                Submit
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </KisshtDialog>
  );
};

CommonRemarksModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default CommonRemarksModal;